export const labels = {
	// reused labels
	bringToFrontTooltip: {
		label: "Label.MobileCreator.Tooltip.Forward",
		default: "Forward",
	},
	sendToBackTooltip: {
		label: "Label.MobileCreator.Tooltip.Backward",
		default: "Backward",
	},
	textPositionTooltip: {
		label: "Label.MobileCreator.Tooltip.Position",
		default: "Position",
	},
} as const;
